var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"integrity-item-main",class:{ 'integrity-item-main-mobile': _vm.isMobile }},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.data.title))]),_c('div',{staticClass:"main"},[_vm._v(_vm._s(_vm.data.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }